import { Leaf } from "lucide-react";
import { useId } from "react";
import { cn } from "../../utils/format";

/** Selo circular "100% fresco" com o texto girando devagar. */
export const FreshSeal = ({ className }: { className?: string }) => {
  const pathId = `seal-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;

  return (
    <div className={cn("relative size-28 sm:size-32", className)}>
      <svg
        viewBox="0 0 120 120"
        role="img"
        aria-label="Selo 100% fresco"
        className="size-full animate-spin-slow motion-reduce:animate-none"
      >
        <defs>
          <path id={pathId} d="M60,60 m-44,0 a44,44 0 1,1 88,0 a44,44 0 1,1 -88,0" />
        </defs>
        <circle cx="60" cy="60" r="58" fill="#0A0A0A" stroke="#FFC107" strokeWidth="2" />
        <circle cx="60" cy="60" r="31" fill="none" stroke="#2A2A2A" strokeDasharray="3 4" />
        <text
          fill="#FFC107"
          fontFamily="Poppins, sans-serif"
          fontSize="11"
          fontWeight="600"
          letterSpacing="2"
        >
          <textPath href={`#${pathId}`} textLength="270" lengthAdjust="spacing">
            100% FRESCO • FEITO NA HORA •
          </textPath>
        </text>
      </svg>
      <span className="absolute inset-0 grid place-items-center">
        <Leaf className="size-8 text-primary" aria-hidden="true" />
      </span>
    </div>
  );
};
